/**
 * 按钮组件
 * 尽量使用libs中的Button组件
 * author: wangbo16
 */
import React from 'react';
import TouchOpacity from '@components/TouchOpacity';

import styles from './index.module.scss';
import classNames from 'classnames';

interface IButtonProps {
  onClick?: (any) => void;
  disable?: boolean;
  className?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  theme?: 'primary' | 'default' | 'ghost';
}

const Button = (props: IButtonProps) => {
  const {
    children,
    onClick,
    className = '',
    disable = false,
    style = {},
    theme
  } = props;

  const handleClick = (e) => {
    if (disable) return;
    onClick && onClick(e);
  };

  return (
    <button
      type="button"
      style={style}
      className={classNames(
        styles['btn-common'],
        className,
        disable ? styles['btn-disable'] : '',
        theme ? styles[theme] : ''
      )}
      onClick={handleClick}
    >
      <div className={styles['btn-common-wrapper']}>{children}</div>
    </button>
  );
};

export default TouchOpacity(Button);
